import { push } from '@lagunovsky/redux-react-router'
import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { H_CAMPAIGN_INSTALLATION_TRACKING } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import CampaignTracking from '../../../campaign/components/campaignTracking/CampaignTracking'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { useParams } from 'react-router'


const InstallationCampaignTrackingApp = ({}) => {
    const {
        installationsLight,
    } = useSelector(store => ({
        installationsLight: store.InstallationReducer.installationsLight,
    }), shallowEqual)

    const dispatch = useDispatch()
    const { id } = useParams()

    useEffect(() => {
        if (!componentHasHabilitations(H_CAMPAIGN_INSTALLATION_TRACKING)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
            return
        }
        dispatch(CampaignAction.fetchInstallationCampaignEvent(id))
    }, [dispatch, id])

    return (
        <CampaignTracking
            stations={installationsLight}
            stationType='installation'
        />
    )
}

export default InstallationCampaignTrackingApp